export const brandName = () => window.appBrandName;
export const logoUrl = () => window.appLogoUrl;
export const supportEmail = 'mary@strongrfastr.com';
export const dateFormat = 'YYYY-MM-DD';
export const dateFormatRegex = /^\d{3,5}-\d{2}-\d{2}$/;
export const iosRatingUrl = `itms-apps://itunes.apple.com/app/viewContentsUserReviews/id${window.iosAppId}?action=write-review`;
export const androidRatingUrl = `https://play.google.com/store/apps/details?id=${window.androidPackageName}`;
export const macroColors = {
    protein: '#3fa054',
    fat: '#FF9900',
    carbs: '#3366CC',
    fiber: '#979dac',
    alcohol: '#990099'
}
export const calRoundFactor = 50.0;
export const NUTRITION = 'nutrition';
export const TRAINING = 'training';
export const FULL = 'full';
export const CLEARED_FILTERS = { trainerId: 'me', status: 'active', setup: null, tag: null, goal: null, routineId: null, gender: null, query: ''};
export const TPAYWALL = 'trainer_paywall';
export const TSIGNUP = 'trainer_signup';
export const TSIGNUP_CONTEXTS = [TPAYWALL,TSIGNUP];